import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationVisitorTypeMaintenance } from "./shared/data.service";
import { DialogService } from "primeng/dynamicdialog";
import { MsAddVisitorTypeComponent } from "./ms-add-visitor-type/ms-add-visitor-type.component";
import { UserService } from "../../../shared";
import { MsEditVisitorTypeComponent } from "./ms-edit-visitor-type/ms-edit-visitor-type.component";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "app-multi-station-visitor-type-maintenance",
	templateUrl: "./multi-station-visitor-type-maintenance.component.html",
	styleUrls: ["./multi-station-visitor-type-maintenance.component.css"],
})
export class MultiStationVisitorTypeMaintenanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private visitorService: DataService_MultiStationVisitorTypeMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadVisitorType();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	ToggleText: string = "Deactivate Type";

	user: any;

	pagerows: number = 10;
	pagefirst: number = 0;
	loading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	//Main
	SelectedVisitorType: any;
	lstVisitorType: any = [];

	//Filter lists
	lstDefinedByDesc: any = [];
	lstActiveDesc: any = [];
	lstCanEditDesc: any = [];

	MaxActive: number = 0;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadVisitorType() {
		this.loading = true;

		this.errorMessage = "";
		this.onRowUnselect(null);

		var result = this.visitorService.VisitorTypeTableInfoSelect();
		result.subscribe(
			(response: any) => {
				this.MaxActive = response.MaxActive;
				this.lstVisitorType = response.lstInfo;

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstVisitorType.map((item: any) => item.DefinedByDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstVisitorType.map((item: any) => item.ActiveDesc))).sort();
				this.lstCanEditDesc = Array.from(new Set(this.lstVisitorType.map((item: any) => item.CanEditDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadVisitorType();
	}

	//Custom Button Methods
	onAddType() {
		this.errorMessage = "";

		if (this.CountActive() >= this.MaxActive) {
			this.errorMessage = "You can only have " + this.MaxActive + " types active at a time. Please deactivate a type before you add new ones";
			return;
		}

		var ref = this.dialogService.open(MsAddVisitorTypeComponent, {
			header: "Add Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadVisitorType();
			}
		});
	}

	onEditType() {
		this.errorMessage = "";

		if (this.SelectedVisitorType == undefined) {
			this.errorMessage = "Select a Visitor Type";
			return;
		}
		if (this.SelectedVisitorType.DefinedByID <= 2) {
			this.errorMessage = "System-Defined Types cannot be edited, only deactivated";
			return;
		}
		if (this.SelectedVisitorType.CanEdit == false) {
			this.errorMessage = "Types that have already been used cannot be edited, only deactivated";
			return;
		}

		var ref = this.dialogService.open(MsEditVisitorTypeComponent, {
			header: "Edit Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				VisitorTypeID: this.SelectedVisitorType.VisitorTypeID,
				VisitorTypeDesc: this.SelectedVisitorType.VisitorTypeDesc,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadVisitorType();
			}
		});
	}

	onToggleType() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedVisitorType == undefined) {
			this.errorMessage = "Select a Visitor Type";
			return;
		}

		var changeTo = this.SelectedVisitorType.Active == true ? 0 : 1;

		if (changeTo == 1 && this.CountActive() >= this.MaxActive) {
			this.errorMessage = "You can only have " + this.MaxActive + " types active at a time. Please deactivate a type before you activate new ones";
			return;
		}

		this.Processing = true;

		//Call SP
		var result = this.visitorService.VisitorTypeToggle(this.SelectedVisitorType.VisitorTypeID, changeTo);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.onRowUnselect(null);
					this.loadVisitorType();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (changeTo == 1 ? "Activate" : "Deactivate") + " the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onDeleteType() {
		this.errorMessage = "";

		this.errorMessage = "";

		//Error handling
		if (this.SelectedVisitorType == undefined) {
			this.errorMessage = "Select a Visitor Type";
			return;
		}
		if (this.SelectedVisitorType.DefinedByID <= 2) {
			this.errorMessage = "System-Defined Types cannot be deleted, only deactivated";
			return;
		}
		if (this.SelectedVisitorType.CanEdit == false) {
			this.errorMessage = "Types that have already been used cannot be deleted, only deactivated";
			return;
		}

		this.confirmationService.confirm({
			key: "mainconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: `Are you sure you want to delete the Visitor Type: ${this.SelectedVisitorType.VisitorTypeDesc}?`,
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.FinishDeleteType();
			},
		});
	}

	FinishDeleteType() {
		this.Processing = true;

		//Call SP
		var result = this.visitorService.VisitorTypeDelete(this.SelectedVisitorType.VisitorTypeID);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.onRowUnselect(null);
					this.loadVisitorType();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedVisitorType = val.data;
		this.errorMessage = "";

		this.ToggleText = "Deactivate Type";
		if (this.SelectedVisitorType.Active == false) {
			this.ToggleText = "Activate Type";
		}
	}
	onRowUnselect(val) {
		this.SelectedVisitorType = null;

		this.ToggleText = "Deactivate Type";
	}
	onRowDblClick(VisitorType) {
		this.SelectedVisitorType = VisitorType;
		this.onEditType();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CountActive(): number {
		var count = 0;

		for (var z = 0; z < this.lstVisitorType.length; z++) {
			var next = this.lstVisitorType[z];

			if (next.Active == true) {
				count++;
			}
		}

		return count;
	}

	////////////////////////////////////////////
}
